import styled from 'styled-components';
export var Table = styled.table.withConfig({
  displayName: "partials__Table",
  componentId: "sc-bttyws-0"
})(["width:100%;text-align:center;border-collapse:separate;border-spacing:0 9px;tr{th:first-child{padding-left:14px;text-align:left;}}th{font-weight:500;}td{padding:14px 0;}thead{color:", ";}tbody{tr{box-shadow:rgb(0 0 0 / 0.1) 0 1px 3px 0,rgb(0 0 0 / 0.06) 0 1px 2px 0;margin:9px;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondary;
});